










































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { MelosStation, MelosContentType } from '@/services/api.service';
import MelosInput from '@/components/MelosInput.vue';
import MelosButton from '@/components/MelosButton.vue';

@Component({
  components: {
    MelosInput,
    MelosButton,
  },
})
export default class StationSlotContent extends Vue {

  private expandedContent: number[] = [];

  private get index(): number {
    return Number(this.$route.params.index || 0);
  }

  private get stationData(): MelosStation {
    return this.$store.state.ownedStations.find((station: MelosStation) => {
      return station._id === this.$route.params.stationId;
    });
  }

  private get currentPeriod() {
    return (this.stationData.period_config || [])[this.index || 0] || {};
  }

  private removeSlotContent(contentIndex: number) {
    this.toggleContentExpansion(contentIndex);
    this.stationData.period_config[this.index].content.splice(contentIndex, 1);
    this.onStationChanged();
  }

  private removeSlot() {
    const hasPrevious = this.index > 0;
    const hasNext = this.index < this.stationData.period_config.length - 1;
    if (hasPrevious) {
      const endTime = this.stationData.period_config[this.index].end;
      this.stationData.period_config[this.index - 1].end = endTime;
    } else if (hasNext) {
      const startTime = this.stationData.period_config[this.index].start;
      this.stationData.period_config[this.index + 1].start = startTime;
    }
    this.stationData.period_config.splice(this.index, 1);
    this.onStationChanged();
    this.$router.replace(`/stations/${this.stationData._id}/schedule`);
  }

  @Watch('currentPeriod.content')
  private async onStationChanged() {
    return this.$apiService.updateStation(this.stationData);
  }

  private get slotData() {
    return (this.stationData?.period_config || [])[this.index];
  }

  private get slotStart(): string {
    return this.getSlotTime(this.stationData?.period_config[this.index].start);
  }

  private set slotStart(timeString: string) {
    const hasPrevious = this.index > 0;
    if (timeString.length < 5 || !hasPrevious) {
      return;
    }
    this.stationData.period_config[this.index].start = timeString.split(':').join('') + '00';
    const startTime = this.stationData.period_config[this.index].start;
    this.stationData.period_config[this.index - 1].end = startTime;
    this.onStationChanged();
  }

  private get slotEnd(): string {
    return this.getSlotTime(this.stationData?.period_config[this.index].end);
  }

  private set slotEnd(timeString: string) {
    const hasNext = this.index < this.stationData.period_config.length - 1;
    if (timeString.length < 5 || !hasNext) {
      return;
    }
    this.stationData.period_config[this.index].end = timeString.split(':').join('') + '00';
    const endTime = this.stationData.period_config[this.index].end;
    this.stationData.period_config[this.index + 1].start = endTime;
    this.onStationChanged();
  }

  private get stationName(): string {
    return this.stationData?.name || '';
  }

  private toggleContentExpansion(contentIndex: number) {
    const itemIndex = this.expandedContent.findIndex((expandedIndex) => {
      return expandedIndex === contentIndex;
    });
    if (itemIndex === -1) {
      this.expandedContent.push(contentIndex);
    } else {
      this.expandedContent.splice(itemIndex, 1);
    }
  }

  private async addNewContent() {
    this.stationData.period_config[this.index].content.push({
      name: 'Pop',
      tag: 'pop',
      type: MelosContentType.TAG_BASED,
      provider: 'jamendo',
      weight: 0.25,
    });
    return this.refreshWeights(this.stationData.period_config[this.index].content.length - 1);
  }

  private async refreshWeights(contentIndex: number) {
    this.stationData.period_config[this.index].content[contentIndex].weight = Number(
      this.stationData.period_config[this.index].content[contentIndex].weight,
    );
    const totalWeight = this.stationData.period_config[this.index].content.reduce(
      (weight, currentContent, index) => {
        return weight + Number(currentContent.weight || 0);
      }, 0,
    );
    const weightDifference = 1 - totalWeight;
    const weightOffset = weightDifference / (this.stationData.period_config[this.index].content.length - 1);
    for (let i = 0; i < this.stationData.period_config[this.index].content.length; i++) {
      const contentData = this.stationData.period_config[this.index].content[i];
      if (i !== contentIndex) {
        contentData.weight = Math.max(0, Number(contentData.weight || 0) + weightOffset);
      }
    }

    return this.onStationChanged();
  }

  private getSlotEndTime(start: string, duration: number): string {
    const hour = Number(start.slice(0, 2));
    const minute = Number(start.slice(2, 4));
    const second = Number(start.slice(4, 6));
    return `${hour + Math.trunc(duration / 3600)}${minute + Math.trunc(duration / 60)}${second + (duration % 3600)}`;
  }

  private getSlotDuration(slotData: any): number {
    const startHour = Number(slotData.start.slice(0, 2));
    const startMinute = Number(slotData.start.slice(2, 4));
    const startSecond = Number(slotData.start.slice(4, 6));
    const endHour = Number(slotData.end.slice(0, 2));
    const endMinute = Number(slotData.end.slice(2, 4));
    const endSecond = Number(slotData.end.slice(4, 6));
    const startDaySecond = startHour * 3600 + startMinute * 60 + startSecond;
    const endDaySecond = endHour * 3600 + endMinute * 60 + endSecond;
    return endDaySecond - startDaySecond;
  }

  private getSlotTime(timeData: string): string {
    const hour = timeData.slice(0, 2);
    const minute = timeData.slice(2, 4);
    return `${hour}:${minute}`;
  }

}
